// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"d390f5df","396":"84ea89d7","613":"e069cb11","692":"d8ce5e54","892":"3f1b69ac"}[chunkId] + ".chunk.js";
};